import { render } from "./BsCheckbox.vue?vue&type=template&id=6c27d1a6&scoped=true&ts=true"
import script from "./BsCheckbox.vue?vue&type=script&lang=ts"
export * from "./BsCheckbox.vue?vue&type=script&lang=ts"

import "./BsCheckbox.vue?vue&type=style&index=0&id=6c27d1a6&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c27d1a6"]])

export default __exports__